import { createContext, ReactElement, ReactNode, useContext } from 'react';
import { PlaceOrderParams } from 'interfaces';

export enum CartStepEnum {
  Explore,
  Payment,
  Success,
  Fail
}

type CartProps = {
  children: ReactNode;
  value: {
    cartStep: CartStepEnum;
    setCartStep: (arg: CartStepEnum) => void;
    goBack: () => void;
    cartPrice: string;
    setCartPrice: (arg: string) => void;
    handleCheckout: (params?: Partial<PlaceOrderParams>) => void;
    checkoutLoading: boolean;
    checkoutErrorMessage: string;
  };
};

export const CartContext = createContext<CartProps['value']>({
  cartStep: CartStepEnum.Explore,
  setCartStep: () => {},
  goBack: () => {},
  cartPrice: '',
  setCartPrice: () => {},
  handleCheckout: () => {},
  checkoutLoading: false,
  checkoutErrorMessage: ''
});

export const CartProvider = (props: CartProps): ReactElement => {
  return (
    <CartContext.Provider value={props.value}>
      {props.children}
    </CartContext.Provider>
  );
};

export const useCartValues = (): CartProps['value'] => {
  return useContext(CartContext);
};
